document.querySelector('.articles__more')?.addEventListener('click', e => {
  if (e.currentTarget.classList.contains('show')) {
    e.currentTarget.textContent = 'Show All';
  } else {
    e.currentTarget.textContent = 'Hide';
  }
  e.currentTarget.classList.toggle('show');
  e.currentTarget.previousElementSibling.classList.toggle('show');
});
